<template>
  <div>
    <el-table
      v-bind:data="displayMedicationCompliance"
      :show-header="false"
      row-key="id"
      @row-click="selectRow"
      :expand-row-keys="expand"
      empty-text="No active medications recorded"
      style="width: 100%"
    >
      <!-- Expandable message history list -->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <!-- Show as-needed medication history -->
          <MedicationAsNeeded
            v-if="scope.row.as_needed"
            :medication="scope.row"
          >
          </MedicationAsNeeded>
          <!-- Show periodic medication compliance history -->
          <MedicationCompliance v-else :medication="scope.row">
          </MedicationCompliance>
        </template>
      </el-table-column>

      <!-- Show a medication icon next to each medication -->
      <el-table-column width="50">
        <template slot-scope="scope">
          <img class="medication-icon" src="../image/medication_icon.png" />
        </template>
      </el-table-column>

      <el-table-column prop="title" width="250">
        <template slot-scope="scope">
          <div style="line-height:16px">
            <strong>{{ scope.row.name }}</strong>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="title" width="250">
        <template slot-scope="scope">
          <div style="line-height:16px" v-html="getMedicationString(scope.row)">
            <!-- <small v-if="scope.row.as_needed">
						{{ formatCount(scope.row.compliance.length, 'dose') }} recorded
					</small>
					<small v-else>
						{{ formatCount(scope.row.compliance.length, 'week') }} recorded
					</small> -->
          </div>
        </template>
      </el-table-column>

      <el-table-column width="120">
        <template slot-scope="scope">
          <!-- <DateRange :row="scope.row"></DateRange> -->
        </template>
      </el-table-column>

      <el-table-column>
        <template slot-scope="scope">
          <div>
            <!-- graph -->
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="show-more" v-if="showRows < medicationCompliance.length">
      <el-button type="text" @click="showMore">
        {{ showMoreText }}&nbsp;<i class="el-icon-arrow-down"></i>
      </el-button>
    </div>
    <div
      class="show-more"
      v-if="showRows >= medicationCompliance.length && this.showLess"
    >
      <el-button type="text" @click="showLessHandler">
        {{ showLessText }}&nbsp;<i class="el-icon-arrow-up"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import CardTable from "../component/table";

import MedicationCompliance from "./analysis/Compliance";
import MedicationAsNeeded from "./analysis/AsNeeded";

import { getMedicationString } from "@/module/patient/card/chart/generate/medication.js";

export default {
  name: "patient-medication-card-table",
  extends: CardTable,

  props: {
    patient: {
      type: Object,
      required: true,
    },
    medication: {
      type: Array,
    },
    compliance: {
      type: Array,
    },
    dose: {
      type: Array,
    },
  },

  data() {
    return {
      showRows: 3,
      showLess: false,
    };
  },

  methods: {
    getMedicationString,

    showMore() {
      this.showLess = true;
      this.showRows += 10;
    },
    showLessHandler() {
      this.showLess = false;
      this.showRows = 3;
    },
  },

  computed: {
    medicationCompliance() {
      var result = this.medication.map((medication) => {
        if (medication.as_needed)
          medication.compliance = this.dose.filter(
            (dose) => dose.medication === medication.id
          );
        else
          medication.compliance = this.compliance.filter(
            (compliance) => compliance.medication === medication.id
          );
        return medication;
      });
      result.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      });
      return result;
    },

    displayMedicationCompliance() {
      return this.medicationCompliance.slice(0, this.showRows);
    },

    showMoreText() {
      return "Show more";
    },
    showLessText() {
      return "Show less";
    },
  },

  components: {
    MedicationCompliance,
    MedicationAsNeeded,
  },
};
</script>

<style lang="scss" scoped>
.show-more, .el-button:hover, .el-button:focus {
  .el-button {
    display: block;
    width: 100%;
    font-size: 14px;
    color: #4a9bf9;
    font-weight: 600;
  }
  .el-icon-arrow-down {
    font-weight: 700;
  }
}

.medication-icon {
  float: left;
  width: 32px;
  height: 32px;
}
</style>
